import React from "react";
import { Router, Route, browserHistory, IndexRoute } from 'react-router';
import '../css/bootstrap.css'
import '../css/fontello.css';
import '../css/bootstrap-datetimepicker.min.css';
import '../css/bootstrap-select.min.css';
import '../css/glweb.css';
import HomePage from '../components/homePage';
import IssueFeedback from '../components/feedback/issueFeedback';
// import EnterDetails from '../components/enterdetails';
// import AddVehicle from '../components/addVehicle.js';
import DashBoard from '../components/dashBoard';
import { DailyRidesPage } from '../components/dailyRides/dailyRidePage';
import CustomRides from '../components/customRides';
import ShowRideDetails from '../components/showRideDetails';
import LoginPage from '../components/login';
import PageNotFound from '../components/pageNotFound';
import chkUnauthorized from '../funnel/chkUnauthorized';
import AddGeoFence from '../components/geoFence/addGF';
import ViewGeoFence from '../components/geoFence/viewGF';
import EditGeoFence from '../components/geoFence/editGF';
import AddSpeedLimit from '../components/spdLimit/addSL';
import Rides from '../components/dailyRides/rides';
import ViewSpeedLimit from '../components/spdLimit/viewSL';
import EditSpeedLimit from '../components/spdLimit/editSL';
import AllVehStatsTiles from '../components/statistics/allVehStatsTiles';
import AddShipment from '../components/trips/addTrip';
import ViewShipments from '../components/trips/viewShipments';
import Sessions from '../components/settings/sessions';
import Notification from '../components/notifications/tlNotifs';
import DailyStats from '../components/dailyRides/dailyStats';
import DetailedStats from '../components/dailyRides/detailedStats';
import TimelineRideLog from '../components/dailyRides/rideLog';

// import DealerDashboard from '../components/dealerDashboard';
import ServiceList from '../components/serviceList';
import ServicePanel from '../components/servicePanel';
import ProfileSettings from '../components/profileSettings';
import SalesPanel from '../components/salesPanel';
import AccountDetails from '../components/accountDetails';
import GetRideLog from '../components/getRideLog';
import Debugger from "../components/debugger";

var route_path = "/webapptl";
var routes = (
  <Router history={browserHistory}>
    <Route path={route_path} component={HomePage}>
      <IndexRoute component={LoginPage}/>
      <Route component={chkUnauthorized} >
        {/*<Route path="/addvehicle" component={AddVehicle}/>*/}
        <Route path={route_path + "/dashboard"} component={DashBoard} />
        <Route path={route_path + "/dailyStats"} component={DailyStats} />
        <Route path={route_path + "/dailyStats/detailedStats"} component={DetailedStats} />
        <Route path={route_path + "/tlridelog"} component={TimelineRideLog} />
        <Route path={route_path + "/dailyRidesPage"} component={DailyRidesPage} />
        <Route path={route_path + "/dailyRidesPage/rides"} component={Rides} />
        <Route path={route_path + "/allvehstat"} component={AllVehStatsTiles} />
        <Route path={route_path + "/notifs"} component={Notification} />
        <Route path={route_path + "/customRides"} component={CustomRides} />
        <Route path={route_path + "/showridedetails"} component={ShowRideDetails} />
        <Route path={route_path + "/gf/add"} component={AddGeoFence} />
        <Route path={route_path + "/gf/view"} component={ViewGeoFence} />
        <Route path={route_path + "/gf/edit"} component={EditGeoFence} />
        <Route path={route_path + "/sl/add"} component={AddSpeedLimit} />
        <Route path={route_path + "/sl/view"} component={ViewSpeedLimit} />
        <Route path={route_path + "/sl/edit"} component={EditSpeedLimit} />
        <Route path={route_path + "/sp/add"} component={AddShipment} />
        <Route path={route_path + "/sp/upcoming"} component={ViewShipments} />
        <Route path={route_path + "/sp/ongoing"} component={ViewShipments} />
        <Route path={route_path + "/sp/completed"} component={ViewShipments} />
        <Route path={route_path + "/sessions"} component={Sessions} />
        {/* <Route path="/dailyrides" component={ShowDailyRides} /> */}

        <Route path={route_path + "/serviceList"} component={ServiceList} />
        <Route path={route_path + "/servicePanel"} component={ServicePanel} />
        <Route path={route_path + "/profileSettings"} component={ProfileSettings} />
        <Route path={route_path + "/salesPanel"} component={SalesPanel} />
        <Route path={route_path + "/accountdetails"} component={AccountDetails} />
        <Route path={route_path + "/rideLogs"} component={GetRideLog} />
        <Route path={route_path + "/debugger"} component={Debugger} />
      </Route>
    </Route>
    <Route path="/i/:id" component={IssueFeedback}></Route>
    <Route path="*" component={PageNotFound} />
  </Router>
)
export default routes;